import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-dashboard-global-modal',
	template: `
		<nb-card class="no-edge-card mb-0 dashboard-global-modal-card">
			<div class="closeModal">
				<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }"
					(click)="closeModal()" nbTooltip="Cerrar" nbTooltipPlacement="left">
				</nb-icon>
			</div>
			<nb-card-header class="border-bottom-0 dashboard-modal-header">
				<div class="d-flex align-items-center gap-3">
					<nb-icon icon="bar-chart-outline" class="header-icon"></nb-icon>
					<div>
						<h4 class="m-0 header-title">Dashboard global - Estudio Científico</h4>
						<small class="header-subtitle">Datos agregados de todos los centros</small>
					</div>
				</div>
			</nb-card-header>
			<nb-card-body class="p-0">
				<app-dashboard-estudio
					[level]="'global'"
					[autoLoad]="true">
				</app-dashboard-estudio>
			</nb-card-body>
		</nb-card>
	`,
	styles: [`
		.dashboard-global-modal-card { height: 100%; display: flex; flex-direction: column; }
		.dashboard-modal-header {
			background: #3366ff;
			color: #fff;
			padding: 1rem 2rem;
		}
		.dashboard-modal-header .header-icon { font-size: 2rem; color: #fff; }
		.dashboard-modal-header .header-title { color: #fff; font-weight: 600; }
		.dashboard-modal-header .header-subtitle { color: rgba(255, 255, 255, 0.7); font-size: 0.85rem; }
		.dashboard-global-modal-card .closeModal nb-icon { color: #fff !important; }
	`],
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class DashboardGlobalModalComponent {

	constructor(public activeModal: NgbActiveModal) {}

	closeModal() {
		this.activeModal.close();
	}
}
